import { render, staticRenderFns } from "./StockTaking.vue?vue&type=template&id=07fd31f7&"
import script from "./StockTaking.vue?vue&type=script&lang=ts&"
export * from "./StockTaking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports